import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type { PropertySearchItem } from '~/layouts/components/app-menu/property-search/http/types'

export class PropertySearchAPI extends Http {
  search = (keyword: string): Promise<PropertySearchItem[]> => {
    return this.callAuthAPI<null, PropertySearchItem[]>(HttpMethod.GET, {
      path: APIPaths.PROPERTIES_SEARCH,
      query: { keyword },
    })
  }
}

export const usePropertySearchAPI = (): PropertySearchAPI => {
  return new PropertySearchAPI()
}
